import { useState, useCallback } from 'react'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default function useDownloadSmartPageImags() {
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState(0)

    /**
     * @param {Array} list 任务数组（每项里有 results）
     * @param {String} zipName zip 文件名（如：xxx.zip）
     */
    const downloadZip = useCallback(async (list, zipName) => {
        if (!Array.isArray(list) || !list.length) return

        const finalZipName = zipName || '智能详情页切图.zip'

        setLoading(true)
        setProgress(0)

        const zip = new JSZip()
        const imgFolder = zip.folder(
            finalZipName.replace(/\.zip$/i, '')
        )

        /** 🔹 把所有 image 拉平成一个数组 */
        const imageList = list.flatMap(item =>
            Array.isArray(item.results)
                ? item.results
                    .map(r => r.image)
                    .filter(Boolean)
                : []
        )

        if (!imageList.length) {
            setLoading(false)
            return
        }

        let finished = 0
        const total = imageList.length

        try {
            await Promise.all(
                imageList.map(async (url) => {
                    // 取 url 中的文件名
                    const fileName = url.split('/').pop().split('?')[0]

                    const response = await fetch(url)
                    if (!response.ok) {
                        throw new Error(`下载失败: ${url}`)
                    }

                    const blob = await response.blob()
                    imgFolder.file(fileName, blob)

                    finished += 1
                    setProgress(Math.round((finished / total) * 100))
                })
            )

            const content = await zip.generateAsync({ type: 'blob' })
            saveAs(content, finalZipName)
        } catch (err) {
            console.error(err)
        } finally {
            setLoading(false)
        }
    }, [])

    return {
        downloadZip,
        loading,
        progress
    }
}
